var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 85,
    viewBox: "0 0 74 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9504 30.9769L30.9493 27.3912C28.2223 22.5049 21.3699 21.9279 17.075 26.2228C14.4942 28.8036 12.4861 31.9651 12.3536 35.46C12.1819 39.9896 13.0249 46.9541 17.9957 54.4935L31.187 41.3021C34.0314 38.4578 34.7563 34.2128 32.9504 30.9769ZM43.6977 53.8127L30.5063 67.0041C38.0456 71.9748 45.0102 72.8177 49.5397 72.646C53.0346 72.5137 56.1963 70.5055 58.777 67.9248C63.0718 63.6297 62.4949 56.7773 57.6084 54.0504L54.0228 52.0493C50.7869 50.2434 46.542 50.9683 43.6977 53.8127Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.9922 51.0091C27.7369 44.7539 31.1869 41.3037 31.1869 41.3037L17.9956 54.4951C19.4813 56.7484 21.3357 59.0529 23.642 61.3592C25.9483 63.6655 28.2529 65.5198 30.5062 67.0057L43.6976 53.8143C43.6976 53.8143 40.2473 57.2642 33.9922 51.0091Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6666 15C38.2534 15 38.7291 15.5597 38.7291 16.25V17.9167C38.7291 24.5902 43.3275 30 49 30C54.6724 30 59.2708 24.5902 59.2708 17.9167V16.25C59.2708 15.5597 59.7465 15 60.3333 15C60.9201 15 61.3958 15.5597 61.3958 16.25V17.9167C61.3958 25.5497 56.4111 31.8132 50.0625 32.4472V36.25C50.0625 36.9403 49.5867 37.5 49 37.5C48.4132 37.5 47.9375 36.9403 47.9375 36.25V32.4472C41.5888 31.8132 36.6041 25.5497 36.6041 17.9167V16.25C36.6041 15.5597 37.0798 15 37.6666 15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49 3.33301C44.5011 3.33301 40.8541 7.62361 40.8541 12.9163V17.9163C40.8541 23.209 44.5011 27.4997 49 27.4997C53.1386 27.4997 56.5565 23.8685 57.0771 19.1663H50.4166C49.8298 19.1663 49.3541 18.6067 49.3541 17.9163C49.3541 17.226 49.8298 16.6663 50.4166 16.6663H57.1458V14.1663H50.4166C49.8298 14.1663 49.3541 13.6067 49.3541 12.9163C49.3541 12.226 49.8298 11.6663 50.4166 11.6663H57.0771C56.5565 6.96422 53.1386 3.33301 49 3.33301Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3541 17.917C49.3541 18.6073 49.8298 19.167 50.4166 19.167H57.0771L57.1458 16.667H50.4166C49.8298 16.667 49.3541 17.2267 49.3541 17.917Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3541 12.917C49.3541 13.6073 49.8298 14.167 50.4166 14.167H57.1458L57.0771 11.667H50.4166C49.8298 11.667 49.3541 12.2266 49.3541 12.917Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1667 40.0003C72.1667 39.1377 71.7246 38.2749 70.8405 37.7941L60.1639 31.9882C58.4453 31.0537 56.3334 32.2701 56.3334 34.1944V40.0003H72.1667Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.1639 48.0121L70.8405 42.2062C71.7246 41.7254 72.1667 40.8627 72.1667 40H56.3334V45.8059C56.3334 47.7302 58.4453 48.9467 60.1639 48.0121Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMenu);
export default __webpack_public_path__ + "static/media/PhoneMenu.52072bdff0f24e9bca4eac9db82e8a68.svg";
export { ForwardRef as ReactComponent };